import React, { useEffect, useState } from "react";
import upArrow from "../../../assets/icons/upload.png";
import Header from "../header/header";
import Footer from "../footer/footer";
import FeatureRoutes from "../../features/featureRoutes";
import "../../../assets/css/style.css";
import "../layout/layout.css";
import RegistrationForm from "../../RegistrationFormModal/RegistrationForm";
// import Chatbot from "../../features/chatbot/Chatbot";
// import { ToastProvider } from "../../Context/ToastContext.jsx";

export default function Layout() {
  const [showButton, setShowButton] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

      setShowButton(scrollTop > 100);
      setScrollProgress(scrolled);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const [profileImage, setProfileImage] = useState("");

  // This is the function that will update state in parent
  const handleImg = (img) => {
    setProfileImage(img);
  };

  return (
    <>
      <Header image={profileImage} />
      <div className="main_wrapper">
        {/* <ToastProvider> */}
        <FeatureRoutes
          onChange={(img) => {
            handleImg(img);
          }}
        />
        {/* </ToastProvider> */}
        <div className={`goToTop ${showButton ? "visible" : "hidden"}`}>
          <div
            className="go_top_border"
            style={{
              background: `conic-gradient(var(--secondary-color) ${scrollProgress}%, transparent ${scrollProgress}%)`,
            }}
          >
            <button
              className="go_top_btn"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <img src={upArrow} alt="Go to Top" />
            </button>
          </div>
        </div>
      </div>
      <Footer />
      {/* <Chatbot /> */}
    </>
  );
}
